// FullscreenControlCustom.tsx
import { useMap } from "react-leaflet";
import { useEffect } from "react";
import L from "leaflet";
import "leaflet.fullscreen";
import "leaflet.fullscreen/Control.FullScreen.css";

interface FullscreenControlCustomProps {
  position?: L.ControlPosition;
  title?: string;
  titleCancel?: string;
}

const FullscreenControlCustom: React.FC<FullscreenControlCustomProps> = ({
  position = "topright",
  title = "Plein écran",
  titleCancel = "Quitter le plein écran",
}) => {
  const map = useMap();

  useEffect(() => {
    if (!map || !map.getContainer()) return;

    // Bouton toggle (même bouton sert à entrer/sortir)
    const control = L.control.fullscreen({
      position,
      title,
      titleCancel,
      forceSeparateButton: false, // ⚠️ important pour toggle unique
    });

    control.addTo(map);

    const container = map.getContainer();

    const handleFsChange = () => {
      if (document.fullscreenElement === container) {
        console.log("✅ Entré en fullscreen");
      } else {
        console.log("↩️ Sorti du fullscreen");
      }
    };

    // ⚡ écouter le navigateur global
    document.addEventListener("fullscreenchange", handleFsChange);

    return () => {
      map.removeControl(control);
      document.removeEventListener("fullscreenchange", handleFsChange);
    };
  }, [map, position, title, titleCancel]);

  return null;
};

export default FullscreenControlCustom;
